export default "__VITE_ASSET__dd27628d__"